import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Tracks from '../../../../components/pages/artist/management/Tracks';
import {Tracks as actionmodule} from '../../../../actions/index';
const {actions} = actionmodule;

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getAllTracks: actions.getAllTracks,
    createTrack: actions.createTrack,
    updateTrack: actions.updateTrack,
    deleteTrack: actions.deleteTrack,
    downloadTrackArtwork: actions.downloadTrackArtwork,
  }, dispatch);
}



function mapStateToProps(state) {
  const {tracks, io} = state;

  return {
    tracks,
    io
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Tracks);



// WEBPACK FOOTER //
// ./src/containers/pages/artist/management/Tracks.js